/**
 * Tam sayı metin kutuları (adet vb.) — type="number" yerine yalnızca rakam.
 */

/** Girdiden yalnızca rakamları bırakır */
export function sanitizeIntegerDigits(value, { allowEmpty = false } = {}) {
  const digits = String(value ?? '').replace(/\D/g, '');
  if (!allowEmpty && digits === '') return '';
  return digits;
}

/**
 * Pozitif tam sayı parse; geçersiz/boş için fallback (varsayılan min).
 */
export function parsePositiveInt(value, { min = 1, max, fallback } = {}) {
  const fb = fallback !== undefined ? fallback : min;
  const s = sanitizeIntegerDigits(value, { allowEmpty: true });
  if (s === '') return fb;
  const n = parseInt(s, 10);
  if (!Number.isFinite(n)) return fb;
  if (n < min) return min;
  if (max != null && n > max) return max;
  return n;
}

/** Adet alanları için kısayol */
export function parseAdet(value, { min = 1, max, fallback } = {}) {
  return parsePositiveInt(value, { min, max, fallback });
}

export function isValidAdet(value, { min = 1, max } = {}) {
  const s = String(value ?? '').trim();
  if (s === '' || !/^\d+$/.test(s)) return false;
  const n = parseInt(s, 10);
  if (n < min) return false;
  if (max != null && n > max) return false;
  return true;
}
